import UnitSensor       from 'src/stores/application/classes/UnitSensor';
import CachedRecord     from 'src/stores/application/classes/CommCache';
import { Unit }         from 'src/stores/application/unit';
import { ChartPoint }   from 'chart.js';
import convert          from 'convert-units';

export class SortedUnitSensor {
    public name: string;
    public unit: Unit;
    public unitSensor: UnitSensor;
    public datas: CachedRecord[];

    public static sortData (
        unitSensors: UnitSensor[],
        unit: Unit,
        cachedRecords: CachedRecord[]
    ): SortedUnitSensor[] {
        return unitSensors.map(unitSensor => new SortedUnitSensor(unitSensor, unit, cachedRecords));
    }

    constructor (unitSensor: UnitSensor, unit: Unit, Datas: CachedRecord[]) {
        this.name = unitSensor.name;
        this.unitSensor = unitSensor;
        this.unit = unit;
        this.datas = Datas.filter(data => data.unitId === unitSensor.typedId);
    }

    public getTimeSeries (
        fromDate: Date,
        fromUnit: string,
        toUnit: string,
        breakOnError?: Boolean,
        _toDate?: Date
    ) {
        let sortedDatas = this.datas.filter(
            o => fromDate && new Date(o.toTime * 1000) > fromDate &&
                (
                    typeof _toDate ===  'undefined' ||
                    new Date(o.fromTime * 1000) < _toDate 
                )
        ).sort( 
            (p, q) => p.toTime - q.toTime
        );
        let result: ChartPoint[] = [];
        sortedDatas.forEach( (sortedData, ind, arr) => {
            let { fromTime, fromValue } = sortedData;
            
            if (sortedData.isInvalid) {
                if (ind > 0 && !arr[ind - 1].isInvalid) {
                    result.push({
                        x: new Date(arr[ind - 1].toTime * 1000),
                        y: arr[ind - 1].toValue
                    });
                }
                if (breakOnError) {
                    result.push({x: new Date(fromTime * 1000), y: NaN});
                }
            } else {
                result.push({
                    x: new Date(fromTime * 1000),
                    y: convert(Number(fromValue)).from(fromUnit).to(toUnit)
                });
                // result.push({
                //     x: new Date(averageTime * 1000),
                //     y: convert(Number(Number(averageValue).toFixed(2))).from(fromUnit).to(toUnit)
                // });
            }
        });
        if (sortedDatas.length > 0) {
            let lastData = sortedDatas[sortedDatas.length - 1];

            if (!lastData.isInvalid) {
                result.push({
                    x: new Date(lastData.toTime * 1000),
                    y: convert( Number(lastData.toValue) ).from(fromUnit).to(toUnit)
                });
            }
        }
        result.sort(
            (x: {x: Date}, y: {x: Date}) => 
                x.x.getTime() - y.x.getTime()
        );

        return result;
    }
}


// WEBPACK FOOTER //
// ./src/shared/SortedUnitSensorData.ts